// ProductType State

export default {
  productTypeList: [],
  productTypeInfo: {},
  fullProductTypesList: []
}
